<template>
  <div class="contributions">
    <span class="eyebrow-label d-block mb-2">{{
      $t("forwards.deals.commitments.contributions")
    }}</span>

    <p v-if="rows.length === 0" class="text-body-tertiary fs-10 mb-0">
      {{ $t("forwards.deals.commitments.no_escrow") }}
    </p>
    <table v-else class="table table-sm mb-0">
      <thead>
        <tr>
          <th scope="col">{{ $t("forwards.deals.commitments.company") }}</th>
          <th scope="col" class="text-end">{{ $t("forwards.common.mwh") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.company_id">
          <td>{{ row.company_name ?? $t("forwards.common.unknown") }}</td>
          <td class="text-end">{{ formatNumberWithSpaces(row.mwh) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { formatNumberWithSpaces } from "@/composables/formatUtils";
import type { EscrowByCompany } from "@/forwards2/forwardsTypes";

/**
 * Who actually delivered the certificates standing behind one commitment.
 *
 * A mandate's members contribute unevenly — allocation takes whatever each of them produced — so this
 * is the only place the split is visible. Reading only: returning escrow starts from the
 * commitment's own ledger row, where it is visible without opening anything.
 */
defineProps<{
  rows: EscrowByCompany[];
}>();
</script>
